(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/pages/home/components/info-mobile.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/pages/home/components/info-mobile.js');
"use strict";

const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const ContextualAnchor = svs.ticketsValidateManual.components.ContextualAnchor;
const ACCOUNT_INFO_TITLE = 'Spelkonto';
const ACCOUNT_INFO_TEXTS = ['När du vinner på en lott eller ett annat spel hos Svenska Spel sätts dina pengar in på ditt personliga spelkonto. '.concat('Vinsten kan sedan tas ut eller användas för att köpa nya lotter digitalt eller spela andra spel.'), 'Spelkontot behövs för att vi ska kunna säkerställa din identitet och att du är över 18 år gammal, vilket är ett krav för att du ska få spela.'];
setGlobal('svs.ticketsValidateManual.pages.home.components.InfoMobile', _ref => {
  let onScanQrClick = _ref.onScanQrClick;
  return React.createElement(GridRow, null, React.createElement(GridCol, {
    className: "f-body",
    sm: 12
  }, React.createElement("h1", {
    className: "h1"
  }, "R\xE4tta din fysiska lott"), React.createElement("p", {
    className: "p align-left"
  }, "Nu kan du enkelt r\xE4tta din fysiska lott sj\xE4lv. Bara skanna QR-koden p\xE5 lottens baksida med mobilens kamera, eller skriv in lottens sifferserie nedan."), React.createElement("p", {
    className: "p align-left"
  }, "F\xF6r att r\xE4tta och l\xF6sa in eventuell vinst beh\xF6ver du ocks\xE5 ha ett", ' ', React.createElement(ContextualAnchor, {
    texts: ACCOUNT_INFO_TEXTS,
    title: ACCOUNT_INFO_TITLE
  }, "spelkonto"), " hos Svenska Spel."), svs.core.detect.feature('ft-validate-ticket-qr-scanner') && React.createElement(Button, {
    block: true,
    className: "margin-v-2",
    iconPosition: "center",
    inverted: true,
    onClick: onScanQrClick,
    type: "submit"
  }, React.createElement(Icon, {
    icon: "focus"
  }), React.createElement("span", {
    className: "margin-left-half"
  }, "Skanna QR-kod")), React.createElement("img", {
    alt: "QR-kod p\xE5 baksidan av en lott",
    className: "qr-code-img w100 padding-h-2",
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets-validate-manual/qr-code.png")
  }), React.createElement("p", {
    className: "align-left margin-top-1 margin-bottom-0 f-bold"
  }, "H\xE4r kan du skriva in lottens sifferserie. Den best\xE5r av 27 siffror och finns p\xE5 lottens baksida.")));
});

 })(window);